import { DATE_FORMATS } from "../../../utils/Constant";
import moment from "moment";
import Tooltip from "../../../components/Common/Tooltip";
import { FileAddOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomIconInput from "../../../components/CustomForm/CustomIconInput";
import Colors from "../../../themes/Colors";
import { formatearMontoPesos } from "../../../utils/CurrencyUtil";
import { TIPO_DOCUMENTO_CORE } from "../../../utils/LocalData";

export const DEFAULT_ICON_AVATAR = "./images/avatar.png";

export const DEFAULT_MOTIVO_CANCELACION = 8;

export const INITIAL_STATE_MEDICAMENTO_FORM = {
  numeroAfiliado: "",
  cedula: "",
  nss: "",
  nombres: "",
  apellidos: "",
  edad: "",
  fecha: moment(new Date()).format(DATE_FORMATS.middledash_ymd),
  tipoTelefono: "CEL",
  telefono: "",
  tipoServicio: "1",
  correo: "",
  medicoPrescriptor: "",
  diagnostico: "",
  diagnosticoDefinitivo: false,
  requiereFisico: "Si",
  zona: "",
  provincia: "",
  observaciones: "",
  cedulaSuministrada: "",
  plan: "",
  tipoDocumento: TIPO_DOCUMENTO_CORE.CEDULA,
  esSuplementario: false,
  foto: DEFAULT_ICON_AVATAR,
};

export const DEFAULT_ROW = {
  key: 0,
  codigo: "",
  descripcion: "",
  cantidad: "",
  montoReclamado: "",
  montoAutorizado: "",
  montoDiferencia: "",
};

export const DEFAULT_ROW_MEDICAMENTO = {
  key: 0,
  codigo: "",
  descripcion: "",
  cantidad: "",
  montoReclamado: "",
  montoAutorizado: 0,
  montoDiferencia: 0,
};

export const DEFAULT_ROW_DETAIL = {
  key: 0,
  cobertura: "",
  nombreCobertura: "",
  cantidad: "",
  montoReclamado: "",
  montoAutorizado: "",
  montoDiferencia: "",
};

export const DATOS_FIJOS_MEDICAMENTO = {
  CODIGO_TIPO_COBERTURA: "04",
  CODIGO_DIAGNOSTICO_NO_CAPTURADO: "Z006",
  FECHA_VALIDA_HASTA: {
    CANTIDAD_TIEMPO: 30,
    INTERVALO_TIEMPO: "days",
  },
};

export const ESTADO_MEDICAMENTO = {
  VIGENTE: "VIGENTE",
  CANCELADO: "CANCELADO",
};

export const VOUCHER_MEDICAMENTO = {
  HUMANO_ASEGURADO_MATRICIAL: "Voucher_Humano_Asegurado_Matricial",
  HUMANO_ASEGURADO_TERMICO: "Voucher_Humano_Asegurado_Termica",
  HUMANO_PRESTADOR_MATRICIAL: "Voucher_Humano_Prestador_Matricial",
  HUMANO_PRESTADOR_TERMICO: "Voucher_Humano_Prestador_Termica",
  PRIMERA_PRESTADOR_MATRICIAL: "Voucher_ARSprimera_Prestador_Matricial",
  PRIMERA_PRESTADOR_TERMICO: "Voucher_ARSprimera_Prestador_Termica",
};

export const TIPO_ID = {
  PLASTICO: "P",
  CEDULA: "C",
};

export const ESTADO_DIAGNOSTICO_DEFINITIVO = {
  CONFIRMADO: "Confirmado",
  PENDIENTE_CONFIRMAR: "Pendiente confirmar",
};

export const CODIGO_TIPO_SERVICIO_MEDICAMENTO = {
  AMBULATORIO: "1",
  EMERGENCIA: "3",
  ODONTOLOGIA: "8",
  PROMOCION_PREVENCION: "6",
  DIALISIS: "71",
  QUIMIOTERAPIA: "72",
  RADIOTERAPIA: "73",
  GMM: "65",
  ALTO_COSTO: "13",
};

export const DESCRIPCION_PLAN = {
  PLAN_BASICO: "PLAN BASICO DE SALUD",
};

export const DATOS_FIJOS_ZONAS = {
  PAIS_ID: 1,
  TIPO_DISTRIBUCION_POLITICA_ID: 381,
  DEFAULT_ZONA: 1,
};

export const DATOS_FIJOS_PROVINCIAS = {
  PAIS_ID: 1,
  TIPO_DISTRIBUCION_POLITICA_ID: 27,
  DEFAULT_PROVINCIA: 1,
};

export const PAGINAS_MEDICAMENTOS = {
  PAGINA: 1,
  TAMANO: 25,
};

export const CHECK_DIAGNOSTICO_DEFINITIVO = {
  SI_ES_DEFINITIVO: "S",
  NO_ES_DEFINITIVO: "N",
};

export const CHECK_PRIMERA_CONSULTA = {
  SI_ES_PRIMERA_CONSULTA: "S",
  NO_ES_PRMERA_CONSULTA: "N",
};

export const CHECK_FISICO_REQUERIDO = {
  SI_REQUERIDO: "Si",
  NO_REQUERIDO: "No",
};

export const MAXIMO_DIAS_CONSULTA_DIAGNOSTICOS = 60;

export const CONFIG_VOUCHER = {
  MATRICIAL:
    "width=230,height=850,scrollbars=no,menubar=no,location=no,resizable=no",
  TERMICO:
    "width=300,height=850,scrollbars=no,menubar=no,location=no,resizable=no",
};

export const COBERTURAS_MONTOS_MODIFICABLES = [1114, 1067];

export const columnsMedicamentosPermitidos = (onClickAgregar, empresa) => {
  return [
    {
      key: "codigo",
      title: "Código",
      dataIndex: "codigo",
    },
    {
      key: "descripcion",
      title: "Descripción",
      dataIndex: "descripcion",
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) => (
        <Tooltip text="Agregar">
          <FileAddOutlined
            style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 25 }}
            onClick={() => {
              onClickAgregar(record);
            }}
          />
        </Tooltip>
      ),
    },
  ];
};

export const columnsMedicamentosAgregados = (
  handleOpenModalMedicamentos,
  eliminarMedicamento,
  empresa,
  onChangeCantidadMedicamento,
  onChangeMontoReclamadoMedicamento,
  isReadOnlyAfterReclamacion = false
) => {
  return [
    {
      key: "codigo",
      title: "Código",
      dataIndex: "codigo",
      render: (text, record) => {
        return text;
      },
    },
    {
      key: "descripcion",
      title: "Descripción",
      dataIndex: "descripcion",
      render: (text, record) => {
        return record?.key === "totales" ? (
          <strong>{text}</strong>
        ) : (
          text
        );
      },
    },
    {
      key: "cantidad",
      title: "Cantidad",
      dataIndex: "cantidad",
      render: (text, record) => {
        if (record?.key === "totales") {
          return "";
        }
        if (record?.key === 0) {
          return text;
        }

        if (isReadOnlyAfterReclamacion) {
          return text;
        }

        return (
          <CustomIconInput
            type={"text"}
            value={text || ""}
            onChange={(value) => onChangeCantidadMedicamento(record.key, value)}
            placeholder={"Cantidad"}
            width={"120px"}
          />
        );
      },
    },
    {
      key: "montoReclamado",
      title: "Monto Reclamado",
      dataIndex: "montoReclamado",
      render: (text, record) => {
        if (record?.key === "totales") {
          return <strong>{formatearMontoPesos(String(text || 0))}</strong>;
        }
        if (record?.key === 0) {
          return "";
        }

        if (isReadOnlyAfterReclamacion) {
          return formatearMontoPesos(String(text || 0));
        }

        return (
          <CustomIconInput
            type={"text"}
            value={text || ""}
            onChange={(value) =>
              onChangeMontoReclamadoMedicamento(record.key, value)
            }
            placeholder={"Monto reclamado"}
            width={"150px"}
          />
        );
      },
    },
    {
      key: "montoAutorizado",
      title: "Monto Autorizado",
      dataIndex: "montoAutorizado",
      render: (text, record) => {
        if (record?.key === "totales") {
          return <strong>{formatearMontoPesos(String(text || 0))}</strong>;
        }
        return formatearMontoPesos(String(text || 0));
      },
    },
    {
      key: "montoDiferencia",
      title: "Diferencia",
      dataIndex: "montoDiferencia",
      render: (text, record) => {
        if (record?.key === "totales") {
          return <strong>{formatearMontoPesos(String(text || 0))}</strong>;
        }
        return formatearMontoPesos(String(text || 0));
      },
    },
    {
      key: "action",
      title: "Acción",
      render: (text, record) => {
        if (record?.key === "totales" || isReadOnlyAfterReclamacion) {
          return "";
        }
        return record?.key !== 0 ? (
          <Tooltip text="Eliminar">
            <DeleteOutlined
              style={{ color: Colors.huMyHealth, fontSize: 25 }}
              onClick={() => {
                eliminarMedicamento(record);
              }}
            />
          </Tooltip>
        ) : (
          text
        );
      },
    },
  ];
};
